/**
 * This transformer sets `additional_theft_luggage` field to `true` if `additional_theft_abroad`
 * was enabled and to `false` if it was disabled.
 */
export default (kasko) => {
  kasko.addEventListener('form-changed', ({ current, previous }) => {
    if (previous.additional_theft_abroad !== current.additional_theft_abroad) {
      kasko.dispatchEvent('set-form-input', {
        additional_theft_luggage: current.additional_theft_abroad,
      });
    }
  });
};
